import usePrivateLink from "../../config/usePrivateLink";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const StudentHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
    // {
    //   id: "Student report",
    //   title: "Student Report",
    //   icon: "ri-file-chart-line",
    //   path: "/students/report",
    // },
    {
      id: "BanksAccountCreate",
      title: "Student Add",
      icon: "ri-user-add-line",
      path: "/student/add",
    },

    {
      id: "BanksAccountList",
      title: "Student List",
      icon: "ri-list-check",
      path: "/students",
    },

    {
      id: "Admission",
      title: "Admission Form",
      icon: "ri-file-list-3-line",
      // path: "/addmission/form"
      path: "/student/form",
    },

    {
      id: "feeDeposit",
      title: "Fee Deposit",
      icon: "ri-money-rupee-circle-line",
      path: "/fees/collection",
    },

    {
      id: "feeFollowups",
      title: "Fee Followups",
      icon: "ri-phone-line",
      path: "/fees/collection/followUp",
    },

    {
      id: "gatepass",
      title: "Gate Pass",
      icon: "ri-pass-valid-line",
      path: "/GatePass",
    },

    {
      id: "rte",
      title: "RTE Student",
      icon: "ri-book-line",
      path: "/rte",
    },
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <div className="">
      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">
            You don't have permission to access any tabs.
          </div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "bg-label-primary" : ""
                } ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default StudentHeader;
